<template>
    <div class="jump-cart">
        <van-nav-bar title="订单积分统计" left-arrow fixed class="jump-nav-bar" @click-left="back"/>
        <div class="jump-cart-body">
            <!--<van-row style="margin-bottom: 10px">
                <van-cell-group>
                    <van-field
                            v-model="startTime"
                            label="开始时间"
                            placeholder="请选择开始时间"
                            @focus="showDate"
                            readonly
                    />
                    <van-field
                            v-model="endTime"
                            label="结束时间"
                            placeholder="请选择结束时间"
                            @focus="showDate1"
                            readonly
                    />

                    <van-field
                            v-model="name"
                            label="商品名称"
                            placeholder="请输入商品名称"
                    >
                    </van-field>
                    <van-field
                            v-model="code"
                            label="兑换单号"
                            placeholder="请输入兑换单号"
                    >
                        <van-button slot="button" size="small" type="primary" @click="seach">确定</van-button>
                    </van-field>


                </van-cell-group>
            </van-row>-->
            <van-row class="jump-cart-item" type="flex" v-if="integralStatistiExplanation!=''&&integralStatistiExplanation!=null">
                <van-col span="24" v-html="integralStatistiExplanation">

                </van-col>
            </van-row>

            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <van-row class="jump-cart-item" type="flex" v-for="item in list">
                    <van-col span="24">
                            <van-cell title="用户" :value="item.userName" />
                            <van-cell title="商品类型" :value="item.goodsTypeName" />
                            <van-cell title="积分数" :value="item.integralValue" />
                            <van-cell title="消费金额" :value="item.consumeAmount" />
                            <van-cell title="统计开始时间" :value="item.statBeginTime" />
                            <van-cell title="统计结束时间" :value="item.statEndTime" />
                    </van-col>
                </van-row>
            </van-list>
        </div>
        <BackTop />
        <van-popup v-model="popDateShow1" position="bottom" :overlay="true">
            <van-datetime-picker
                    v-model="currentDate1"
                    type="datetime"
                    @cancel="popDateShow = false"
                    @confirm="onDateConfirm1"

            />
        </van-popup>

        <van-popup v-model="popDateShow" position="bottom" :overlay="true">
            <van-datetime-picker
                    v-model="currentDate"
                    type="datetime"
                    @cancel="popDateShow = false"
                    @confirm="onDateConfirm"

            />
        </van-popup>
    </div>
</template>
<script>
    import {DatetimePicker,NavBar, Row, Col, List,Cell, CellGroup,Field,Button,Picker,Popup  } from "vant";

    export default {
        name: "userhistory",
        components: {
            [DatetimePicker.name]: DatetimePicker,
            [Picker.name]: Picker,
            [Popup.name]: Popup,
            [Button.name]: Button,
            [Field.name]: Field,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [List.name]: List
        },
        data() {
            return {
                integralStatistiExplanation:'',
                checkedAll: false,
                list: [],
                loading: false,
                finished: false,
                total: 0,
                page: 1,
                popDateShow:false,
                currentDate:new Date(),
                popDateShow1:false,
                currentDate1:new Date(),
                startTime:'',
                endTime:'',
                name:'',
                code:'',
            };
        }, mounted: function () {
            this.startTime=this.$route.query.time;
        },
        methods: {
            back() {
                history.back();
            },seach(){
                let that = this
                that.list=[]
                that.page=1
                that.$api.post(
                    that.jumuc.integralStatistic,
                    {"currentPage": that.page, "pageSize": 10},
                    successRes => {
                        that.integralStatistiExplanation=successRes.data.integralStatistiExplanation
                        let orderlist = successRes.data.integralStatistiList.list
                        for (let i = 0; i < orderlist.length; i++) {
                            that.list.push(orderlist[i]);
                        }
                        that.page = successRes.data.integralStatistiList.pageNum + 1
                        that.total = successRes.data.integralStatistiList.total
                        // 加载状态结束
                        that.loading = false;

                        // 数据全部加载完成
                        if (this.list.length >= that.total) {
                            that.finished = true;
                        }
                    }
                )
            }, onLoad() {
                let that = this
                // 异步更新数据
                that.$api.post(
                    that.jumuc.integralStatistic,
                    {"currentPage": that.page, "pageSize": 10,"time":this.startTime},
                    successRes => {
                        that.integralStatistiExplanation=successRes.data.integralStatistiExplanation
                        let orderlist = successRes.data.integralStatistiList.list
                        for (let i = 0; i < orderlist.length; i++) {
                            that.list.push(orderlist[i]);
                        }
                        that.page = successRes.data.integralStatistiList.pageNum + 1
                        that.total = successRes.data.integralStatistiList.total
                        // 加载状态结束
                        that.loading = false;

                        // 数据全部加载完成
                        if (this.list.length >= that.total) {
                            that.finished = true;
                        }
                    }
                )

            },showDate() {
                this.popDateShow = true;
            },
            onDateConfirm(value) {
                const d = new Date(value)
                const resDate = d.getFullYear() + '-' + this.p((d.getMonth() + 1)) + '-' + this.p(d.getDate())
                const resTime = this.p(d.getHours()) + ':' + this.p(d.getMinutes()) + ':' + this.p(d.getSeconds())
                this.startTime = resDate + ' ' + resTime;
                this.popDateShow = false;
            },showDate1() {
            this.popDateShow1 = true;
        },
        onDateConfirm1(value) {
            const d = new Date(value)
            const resDate = d.getFullYear() + '-' + this.p((d.getMonth() + 1)) + '-' + this.p(d.getDate())
            const resTime = this.p(d.getHours()) + ':' + this.p(d.getMinutes()) + ':' + this.p(d.getSeconds())
            this.endTime = resDate + ' ' + resTime;
            this.popDateShow1 = false;
        }, p(s) {
                return s < 10 ? '0' + s : s
            }
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;

    body {
        background-color: #f7f7f7;
    }

    .jump-cart {


        .van-hairline--bottom::after {
            border-bottom-width: 0px;
        }
        &-body {
            padding: 20px 10px 0;
            position: relative;
            &-hd {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 80px;
                background-color: @bule-thame;
            }
        }
        &-item {
            background-color: #fff;
            margin-bottom: 15px;
            align-items: center;
            border-radius: 20px;
            padding: 15px;
            position: relative;
            .van-checkbox {
                height: 100%;
                line-height: 100%;
            }
            &-img {
                img {
                    width: 90%;
                }
            }

            h4 {
                font-size: 14px;
                padding: 10px 0;
            }
            &-warp {
                align-self: flex-start;
            }
            p {
                font-size: 14px;
                &.item-time {
                    color: @bule-thame;
                    font-size: 16px;
                    text-align: right;
                }
                &.item-price {
                    color: red;
                    font-size: 16px;
                    i {
                        font-size: 18px;
                        float: right;
                        color: #f5a623
                    }
                }
            }
        }
    }
</style>

